import { FC } from 'react'
import { useNavigate } from 'react-router-dom'
import { ExtractItem } from 'src/utils/extractDescription'
import transactionLabel from 'src/utils/transactionLabel'

import { config } from 'src/config'
import { useAuth } from 'src/hooks/auth'
import dateToLine from 'src/utils/dateToLine'
import { documentFormatted } from 'src/utils/documentFormatted'
import toLocaleAmount from 'src/utils/toLocaleAmount'
import { Button } from '../button'
import {
  ButtonWrapper,
  CloseIcon,
  DownloadIcon,
  InfoModal,
  ModalContent,
  ModalHeader,
  Section,
  SectionAccountinfo,
  SectionCPNJ,
  SectionItem,
  SectionPayerName,
  SectionTitle,
} from '../ModalConfirmOperation/styles'
import { PixKeyResponse } from './ProofResponses'

export const PixKey: FC<{ data: ExtractItem; closeModal: () => void }> = ({
  data,
  closeModal,
}) => {
  const { user } = useAuth()
  const txType = data.type.toLowerCase()

  const naviagate = useNavigate()

  if (!txType.includes('pix')) {
    naviagate('/extract')
  }

  function printPDF() {
    if (!data) return null

    const receiptString = JSON.stringify({ ...data, user })

    localStorage.setItem('temp_receipt_to_print', receiptString)

    window.open(`${config.FRONTEND_URL}/PDF`)
  }

  const response = data.response as PixKeyResponse

  const label = transactionLabel(data)

  const beneficiaryName =
    response?.beneficiary?.holder?.name ||
    response?.beneficiary?.holder?.name ||
    data?.data?.transfer?.destination_bank_account?.beneficiaryName ||
    data.direction === 'in' ||
    user.name ||
    'Desconhecido'

  const beneficiaryDocument =
    response?.beneficiary?.holder?.document ||
    data?.data?.transfer?.destination_bank_account?.beneficiaryDocument

  const end2end = data?.data?.transfer?.pix_end2end_id

  return (
    <>
      <ModalHeader>
        <div>
          <span>{label}</span>
          <button onClick={closeModal}>
            <CloseIcon />
          </button>
        </div>
      </ModalHeader>
      <ModalContent>
        <InfoModal>
          <div>
            <span>{response?.beneficiary?.holder?.name}</span>
            <p>R$ {toLocaleAmount(data.amount)}</p>
          </div>
          <span>{dateToLine(data.created_at)}</span>
        </InfoModal>
        <Section>
          <SectionTitle>Pagador</SectionTitle>
          <SectionPayerName>
            <span>NOME</span>
            <p>{response?.payer?.holder?.name || user.name}</p>
          </SectionPayerName>
          <SectionCPNJ>
            <span>Documento</span>
            <p>
              {response?.payer?.holder?.document ||
                documentFormatted(user.document)}
            </p>
          </SectionCPNJ>
          <SectionItem>
            <span>INSTITUIÇÃO</span>
            <p>{response?.payer?.participant?.name || data?.data?.company}</p>
          </SectionItem>
          <SectionAccountinfo>
            <SectionItem>
              <span>AG</span>
              <p>{response?.payer?.branch || data?.data?.agency}</p>
            </SectionItem>
            <SectionItem>
              <span>CONTA</span>
              <p>{response?.payer?.number || data?.data?.account}</p>
            </SectionItem>
          </SectionAccountinfo>
        </Section>
        <Section>
          <SectionTitle>Favorecido</SectionTitle>
          <SectionItem>
            <span>NOME</span>
            <p>{beneficiaryName}</p>
          </SectionItem>
          <SectionItem>
            <span>Documento</span>
            <p>{beneficiaryDocument}</p>
          </SectionItem>
          {end2end && (
            <SectionItem>
              <span>End2EndID</span>
              <p>{end2end}</p>
            </SectionItem>
          )}
          {/* <SectionItem>
            <span>INSTITUIÇÃO</span>
            <p>puxar do dict</p>
          </SectionItem> */}
          {/* <SectionAccountinfo>
            <SectionItem>
              <span>AG</span>
              <p>{response?.beneficiary?.branch}</p>
            </SectionItem>
            <SectionItem>
              <span>CONTA</span>
              <p>{response?.beneficiary?.number}</p>
            </SectionItem>
          </SectionAccountinfo> */}
        </Section>
        <ButtonWrapper>
          <Button
            handleFunction={printPDF}
            Icon={DownloadIcon}
            title="Baixar Comprovante"
          />
        </ButtonWrapper>
      </ModalContent>
    </>
  )
}
